export default "__VITE_ASSET__CYcxVOEt__"